import { useCallback } from 'react';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import { InsertItemLayout } from '../InsertItemLayout/InsertItemLayout';
import { useAssetEditorsContext } from '../../../context/AssetEditorsContextProvider';
import { useAssetViewContext } from 'screens/editorial/asset/context/AssetViewContextProvider';

export const KickerOption = () => {
  const { setKickerHidden } = useAssetViewContext();

  const { kickerEditor } = useAssetEditorsContext();

  // reveal, scroll to, focus, and set kicker
  const revealKicker = useCallback(() => {
    if (!kickerEditor) return;
    setKickerHidden(false);
    requestAnimationFrame(() => {
      kickerEditor.chain().focus().run();
    });
  }, [kickerEditor, setKickerHidden]);

  return (
    <InsertItemLayout
      id="widget-select-kicker"
      title="Kicker"
      icon={<ViewHeadlineIcon />}
      description="Three words or less used to attract attention to a major story."
      action={revealKicker}
    />
  );
};
